/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, identity, none, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import {
  BulkDeleteHpExecuteRequestDto,
  BulkDeleteHpFilterRequestDto,
  BulkDeleteHpInitDto,
  BulkDeleteHpListItemDto,
} from './bulk-delete.dto';
import { BulkDeleteHpListItemMapper } from './bulk-delete.mapper';

@Injectable()
export class BulkDeleteRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  init(): Observable<BulkDeleteHpInitDto> {
    return this.httpGet(`${this.bp}/house-plan-bulk-delete/init`, identity());
  }

  execute(request: BulkDeleteHpExecuteRequestDto): Observable<void> {
    return this.httpPut(
      `${this.bp}/house-plan-bulk-delete/hp-delete`,
      request,
      identity(),
      none());
  }

  findAllAsDataSource(filter: BulkDeleteHpFilterRequestDto): SlicedDataSource<BulkDeleteHpListItemDto> {
    return this.createSlicedDataSourcePost(
      `${this.bp}/house-plan-bulk-delete/list`,
      filter,
      identity(),
      arrayOf(BulkDeleteHpListItemMapper));
  }
}
